import type { ConfirmOptions } from '@shared-ui/platform/hooks/use-confirm.type'
import { useSyncExternalStore } from 'react'

export type ConfirmRequest = ConfirmOptions & { resolve: (value: boolean) => void }

// Императивный стор одного активного confirm-запроса. useConfirm() (web) кладёт сюда запрос
// и возвращает промис, а ConfirmDialogHost подписывается, рисует модалку и резолвит промис.
let current: ConfirmRequest | null = null
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

export function requestConfirm(options: ConfirmOptions): Promise<boolean> {
  // Если предыдущий диалог ещё открыт — закрываем его как «отмена», чтобы не потерять промис.
  current?.resolve(false)

  return new Promise<boolean>((resolve) => {
    current = { ...options, resolve }
    emit()
  })
}

export function resolveConfirm(value: boolean) {
  const request = current
  current = null
  emit()
  request?.resolve(value)
}

function subscribe(callback: () => void) {
  listeners.add(callback)
  return () => {
    listeners.delete(callback)
  }
}

function getSnapshot() {
  return current
}

export function useConfirmRequest(): ConfirmRequest | null {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
